import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Image from 'UIKit/Image'
import Link from 'UIKit/Link'
import OpenEffect from 'UIKit/OpenEffect'
import Text from 'UIKit/Text'
import { MENU_ITEMS } from 'config/constants/menu'
import { RouteConfig } from 'config/constants/route'
import { useRouter } from 'hooks/useRouter'
import { useMemo } from 'react'
import { useUnwatchedNewBonusListener } from 'state/bonus/hooks'
import { useUserBonus } from 'state/bonus/hooks/useUserBonus'
import styled, { css } from 'styled-components'
import theme from 'theme'
import MenuItem from './MenuItem'
import HunnyPlayAppMenu from './component/HunnyPlayAppMenu'

const StyledContainer = styled(OpenEffect)`
  width: 100%;
  padding: 12px 6px;
  overflow-y: auto;
`

const StyledBonusCenterBadge = styled(Flex)<{ $isHaveNewBonus: boolean }>`
  position: absolute;
  top: 3px;
  right: 3px;
  background: ${({ theme: { colors } }) => colors.strokeAlt3};
  padding: 4px 6px;
  border-radius: 40px;
  min-width: 18px;
  min-height: 18px;
  z-index: 11;

  ${({ $isHaveNewBonus }) =>
    $isHaveNewBonus &&
    css`
      @keyframes ping {
        0% {
          transform: scale(1);
          opacity: 0.5;
        }
        100% {
          transform: scale(2);
          opacity: 0;
        }
      }

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 40px;
        background: #fff;
        animation: ping 1.7s ease infinite;
        opacity: 0.25;
        z-index: 10;
      }
    `};
`

const BonusIconContainer = styled(Box)<{ $Active: boolean }>`
  display: block;

  &:hover {
    background: ${theme.colors.gradient.hover};
  }

  ${({ $Active }) =>
    $Active &&
    css`
      background: ${theme.colors.backgroundAlt5};
    `};
`

const StyledText = styled(Text)`
  position: relative;
  z-index: 11;
`

const MenuSmallContent = () => {
  const { pathname } = useRouter()
  const activeMenuItem = useMemo(() => MENU_ITEMS.find((menuItem) => pathname.startsWith(menuItem.route)), [pathname])
  const { bonuses } = useUserBonus()
  const [unwatchedNewBonus, onClose] = useUnwatchedNewBonusListener()

  return (
    <StyledContainer>
      <BonusIconContainer
        as={Link}
        href={RouteConfig.BonusCenter}
        position="relative"
        style={{ cursor: 'pointer' }}
        onClick={onClose}
        $Active={pathname === RouteConfig.BonusCenter}
        data-tooltip-id={'bonus-menu'}
      >
        <Flex justifyContent="center" alignItems="center" height="44px">
          <Box width="30px">
            <Image src="/images/bonus-center-gift.png" height={72} width={81} />
          </Box>
        </Flex>

        <>
          {!!bonuses?.length && (
            <StyledBonusCenterBadge $isHaveNewBonus={unwatchedNewBonus} alignItems="center" justifyContent="center">
              <StyledText fontSize="10px" fontWeight={600}>
                {bonuses?.length}
              </StyledText>
            </StyledBonusCenterBadge>
          )}
        </>
      </BonusIconContainer>

      <Box>
        {MENU_ITEMS.map((item) => {
          return (
            <MenuItem
              key={item.route}
              item={item}
              activeRoute={activeMenuItem?.route}
              small
              attributes={item?.attributes || {}}
            />
          )
        })}
        <HunnyPlayAppMenu isSmall />
      </Box>
    </StyledContainer>
  )
}

export default MenuSmallContent
